export enum SocketIOEventTypeEnum {
  THREAD = 'THREAD',
  DEAL = 'DEAL',
  DEALS_GROUP = 'DEALS_GROUP',
  TASK = 'TASK',
  PROJECT = 'PROJECT',
  NOTIFICATION = 'NOTIFICATION',
  EXTERNAL_NOTIFICATION = 'EXTERNAL_NOTIFICATION',
  TEST = 'TEST',
  HELPDESK = 'HELPDESK',
  BUDGET_REQUEST = 'BUDGET_REQUEST',
  PURCHASE = 'PURCHASE',
  EQUIPMENT_REPORT = 'EQUIPMENT_REPORT',
  CCTV_EVENT_REPORT = 'CCTV_EVENT_REPORT',
}
